var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"w-100",attrs:{"src":require("@/../public/img/user_detailed_activity.jpg"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }